export default {
  name: "bsc",
  chainIds: [56],
  rpcUrls: ["https://bsc-dataseed.binance.org/"],
};
